import React from "react";
import FilterByShareStatus from "./options/filter-by-share-status";
import SearchBookmarks from "./options/search-bookmarks";
import useSearchBookmarks from "utilities/hooks/domain/my-link/use-search-bookmarks";
import useFilterBookmarks from "utilities/hooks/domain/my-link/use-filter-bookmarks";
import MyBookmarksGroupedByLayout from "./my-bookmarks-groups-by-layout";
import MyBookmarksAccordionPanel from "./my-bookmarks-accordion-panel";
import PublicationAccordionPanelHeader from "./accordions/publication-accordion-panel-header";
import { UserBookmarkCountBy } from "models/enumerations/sorting/user-bookmarks/user-bookmark-count-by";
import EmptyMyLinkPanel from "../empty-mylink-panel";
import useBookmarkGroups from "utilities/hooks/queries/my-link/bookmarks/grouped/use-bookmark-groups-query";
import Loader from "atoms/loaders/loader";
import UserBookmarkShareFilterOption from "models/enumerations/filtering/user-bookmarks/user-bookmark-share-filter-option";
import BookmarkCountSortBy from "./options/bookmark-count-sort-by";
import useSortBookmarkCounts from "utilities/hooks/domain/my-link/use-sort-bookmark-counts";
import { t } from "utilities/localization-utils";

const MyBookmarksViewByPublication = () => {
    const { onSortByChange, sortBy } = useSortBookmarkCounts(
        UserBookmarkCountBy.Publication
    );
    const { onSearchTextChange, searchText } = useSearchBookmarks(
        UserBookmarkCountBy.Publication
    );
    const { onShareFilterChange, shareFilter } = useFilterBookmarks(
        UserBookmarkCountBy.Publication
    );
    const { bookmarkGroups, isLoadingCounts } = useBookmarkGroups(
        UserBookmarkCountBy.Publication,
        {
            searchText: searchText,
            sortOption: sortBy,
            bookmarksCreatedByMe:
                shareFilter === UserBookmarkShareFilterOption.PrivateOnly,
        }
    );

    return (
        <MyBookmarksGroupedByLayout
            countBy={UserBookmarkCountBy.Publication}
            dropdowns={
                <>
                    <FilterByShareStatus
                        onChange={onShareFilterChange}
                        shareStatus={shareFilter}
                    />
                    <BookmarkCountSortBy
                        onChange={onSortByChange}
                        sort={sortBy}
                        showBookOrder={true}
                    />

                    <SearchBookmarks
                        searchText={searchText}
                        onChange={onSearchTextChange}
                        placeHolder={t(
                            "myBookmarksTabFilters-searchPublication-placeholder"
                        )}
                    />
                </>
            }>
            {isLoadingCounts ? (
                <Loader />
            ) : (
                <>
                    {bookmarkGroups?.length ? (
                        bookmarkGroups?.map((group) => (
                            <MyBookmarksAccordionPanel
                                key={group.id}
                                id={group.id}
                                groupBy={UserBookmarkCountBy.Publication}
                                filterBookmarksBySearch={false}
                                header={
                                    <PublicationAccordionPanelHeader
                                        title={group.name}
                                        coverImageFileId={group.imageFileId}
                                        numberOfBookmarks={group.count}
                                    />
                                }
                            />
                        ))
                    ) : (
                        <EmptyMyLinkPanel />
                    )}
                </>
            )}
        </MyBookmarksGroupedByLayout>
    );
};

export default MyBookmarksViewByPublication;
